import React from 'react';
import { Alert, Avatar, Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { Icon } from '../Core/Icon';
import { useAuth } from '../../hooks/useAuth';

import { useFileUpload } from '../../hooks/useFileUpload';

const FilesOnBehalfOfUserAlert: React.FC = () => {
  const { t } = useTranslation();
  const { onBehalfOfUser, isOnBehalfOfUser, handleOnBehalfOfUserChange } =
    useAuth();

  const { isUploadingFiles, isUploadingQuickShareFiles } = useFileUpload();

  return (
    <>
      {isOnBehalfOfUser && (
        <Alert
          type="warning"
          message={
            <span>
              {t('common.onBehalfOf')}:{' '}
              <strong>{`${onBehalfOfUser?.firstName} ${onBehalfOfUser?.lastName}`}</strong>
            </span>
          }
          icon={
            <Avatar className="bg-azure-hover">
              <Icon name="UserIcon" className="text-white" />
            </Avatar>
          }
          action={
            <Button
              disabled={isUploadingFiles || isUploadingQuickShareFiles}
              type="link"
              className="underline"
              onClick={() => handleOnBehalfOfUserChange(null)}
            >
              {t('common.exitFromBehalfOfMode')}
            </Button>
          }
          banner
        />
      )}
    </>
  );
};

export default FilesOnBehalfOfUserAlert;
